import { $uc, $http } from "@2kog/pkg-common/utils/api.js";
const domain = import.meta.env.VITE_API;
// 开发环境 '' || VITE_PAY_API
const payDomain = import.meta.env.DEV ? "/" : import.meta.env.VITE_PAY_API;

/**
 * 更新用户信息
 * @param {Object} data 用户信息
 * @param {String} data.lang 语言
 * @param {Object} params
 * @param {String} params.app 应用标识
 * @returns
 */
export function updateUserInfo(data, params) {
    return $uc({ domain }).put("/user/account/i", data, {
        params,
    });
}

/**
 * 获取用户信息
 * @returns {Promise}
 */
export function getUserInfo() {
    return $uc({ domain }).get("/user/account/i");
}

/**
 * 获取用户资产
 * @returns {Promise}
 */
export function getUserAssets() {
    return $http({ domain: payDomain }).get("/api/client/user-assets/i");
}

/**
 * 获取用户meta信息
 * @returns {Promise}
 */
export function getUserMeta(params) {
    return $uc({ domain }).get("/user/i/meta", {
        params,
    });
}

/**
 * 更新用户meta信息
 * @param {Object} data 用户meta信息
 * @returns {Promise}
 */
export function updateUserMeta(data) {
    return $uc({ domain }).post("/user/i/meta", data);
}
